import React, { useState } from "react";
import { csHttp } from "../api/http";

export default function CSHealth() {
  const [res, setRes] = useState("");
  const [err, setErr] = useState("");

  const testHealth = async () => {
    setRes("");
    setErr("");
    try {
      const r = await csHttp.get("/api/health");
      setRes(String(r.data));
    } catch (e) {
      setErr(e?.response?.data?.message || e.message);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <h2>CourierSub – Health Check</h2>
      <button onClick={testHealth}>Test Backend</button>

      {res && <pre style={{ marginTop: 12 }}>{res}</pre>}
      {err && <pre style={{ marginTop: 12, color: "red" }}>{err}</pre>}
    </div>
  );
}
